import { Routes } from '@angular/router';
import { InternalComponent } from './internal.component';
import { guestOnlyCanMatch } from '../../../guards/auth-guest.guard';
import { privateOnlyCanMatch } from '../../../guards/auth-private.guard';

export const internalRoutes: Routes = [
  {
    path: 'internal',
    component: InternalComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'sign-in' },
      {
        path: 'sign-in',
        loadComponent: () =>
          import('../../pages/auth/auth.component').then(
            (x) => x.AuthComponent
          ),
        canMatch: [guestOnlyCanMatch],
      },
      {
        path: 'sign-up',
        loadComponent: () =>
          import('../../pages/auth/auth.component').then(
            (x) => x.AuthComponent
          ),
        canMatch: [guestOnlyCanMatch],
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('../../pages/auth/auth.component').then(
            (x) => x.AuthComponent
          ),
        canMatch: [guestOnlyCanMatch],
      },
      {
        path: 'reset-password/fail',
        loadComponent: () =>
          import('../../pages/auth/auth.component').then(
            (x) => x.AuthComponent
          ),
        canMatch: [guestOnlyCanMatch],
      },
      {
        path: 'checkout/:orderId',
        loadComponent: () =>
          import('../../pages/checkout/checkout.component').then(
            (x) => x.CheckoutComponent
          ),
        canMatch: [privateOnlyCanMatch],
      },
    ],
  },
];
